import { Component } from 'opus-angular-seed-core';
import template from './template.html';

const DEFAULT_PAGE_SIZE = '10';
const PAGE_SIZE_OPTIONS = ['10', '25', '50', '100'];

@Component({
    bindings: {
        list: '=',
        name: '@',
        pageSize: '='
    },
    template
})
export default class {
    constructor ($scope) {
        this.$scope = $scope;
    }

    $onInit () {
        this.pageSizeOptions = PAGE_SIZE_OPTIONS;
        this.pageSize = this.pageSize ? `${this.pageSize}` : DEFAULT_PAGE_SIZE;
    }


    changePageSize () {
        if (!this.list) {
            return;
        }

        this.list.lastQuery.pageSize = parseInt(this.pageSize, 10);
        this.list.lastQuery.page = 1;
        this.list.fetch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/paginationv2/tools/pageSize/index.js